import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getAll() {
    try {
        const response = await apiGet('core', `information`);

        return response;
    } catch (e) { }
}

export async function dsfAdminAdd(name: string, surname: string, mobile: string, email: string) {
    try {
        const response = await apiPost('core', `admin`, {
            name,
            surname,
            mobile,
            email
        });

        return response;
    } catch (e) { }
}

export async function dsfAdminUpdate(id: string, updateBody: any) {
    try {
        const response = await apiPut('core', `admin/${id}`, updateBody);
        return response;
    } catch (e) { }
}

export async function dsfAdminRemove(id: any) {
    try {

        return await apiDelete('core', `admin/${id}`);
    } catch (e) { }
}